import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { cartContainsOnlyFreeTrialBundles } from '../lib/cart';
import { useCartMode } from '../lib/cartModes';
import * as types from '../types';

/**
 * Returns true if the cart contains ONLY free trial bundles (no regular products).
 * Used to conditionally hide multi-dog upsell and promo code inputs.
 */
export default function useCartHasOnlyFreeTrialBundles(): boolean {
  const { cartSelector } = useCartMode();
  const cart = useSelector(cartSelector);
  const products = useSelector((state: types.AppState) => state.config.products);

  return useMemo(() => cartContainsOnlyFreeTrialBundles(cart, products), [cart, products]);
}
